"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { LANDMARK_PATH } from "@/lib/access";

import styles from "./site-header.module.css";

const NAV = [
  { href: "/home", label: "站点首页" },
  { href: "/data", label: "数据部分" },
  { href: "/principles", label: "规则理解" },
  { href: "/clauses", label: "规则拆解" },
  { href: "/planning", label: "在线规划" },
  { href: "/prototype", label: "高保真原型" },
];

export function SiteHeader({ authenticated }: { authenticated: boolean }) {
  const pathname = usePathname();

  // 入口页不展示站内导航；未通过密令验证时也不渲染，避免出现可以点击进入其它页面的菜单
  if (!authenticated || pathname === LANDMARK_PATH) {
    return null;
  }
  // 高保真原型自带固定顶栏与侧栏，站点导航会在其上方占位并被遮挡，形成顶部留白
  if (pathname === "/prototype" || pathname.startsWith("/prototype/")) {
    return null;
  }

  return (
    <header className={styles.header}>
      <Link href="/home" className={styles.brand}>
        <span className={styles.logo} aria-hidden="true" />
        配电网光纤专网规划
      </Link>
      <nav aria-label="主导航" className={styles.nav}>
        {NAV.map((item) => {
          const active = pathname === item.href || pathname.startsWith(`${item.href}/`);
          return (
            <Link key={item.href} href={item.href} className={active ? `${styles.link} ${styles.active}` : styles.link} aria-current={active ? "page" : undefined}>
              {item.label}
            </Link>
          );
        })}
      </nav>
    </header>
  );
}
